import { Injectable, inject } from '@angular/core';

import { BetBuilderConfig } from '@frontend/sports/common/client-config-data-access';

import { BetslipPick } from '../../../../../../core/picks/betslip-pick';
import { GroupPickHasLiveLegsPreCheckError } from '../../../../errors/general/group-pick-error';
import { isGroupPickWithRestrictedLiveLegs } from '../../../utils/bet-builder-utils';
import { IPureLinearPickValidator } from '../validators';

@Injectable()
export class GroupPickHasLiveLegsPreCheckValidator implements IPureLinearPickValidator<GroupPickHasLiveLegsPreCheckError> {
    private readonly betBuilderConfig = inject(BetBuilderConfig);

    validate(pick: BetslipPick): GroupPickHasLiveLegsPreCheckError[] {
        const isRestricted = isGroupPickWithRestrictedLiveLegs(this.betBuilderConfig.liveBetBuilderEnabledCompetitions, pick);

        return isRestricted ? [new GroupPickHasLiveLegsPreCheckError(pick.id.toString())] : [];
    }
}
